import React from "react";

import BillingLinkButton from "@app/analytics/account/Billing/components/BillingLinkButton";
import usePaymentMethod from "@app/analytics/account/Billing/hooks/usePaymentMethod";
import useBillingSubscription from "@app/analytics/hooks/billing/useBillingSubscription";
import * as Events from "@app/analytics/tracking/events";
import { toast } from "@app/common/hooks/useToasts";

const ReactivatePlanButton = () => {
  const { reactivateSubscription } = useBillingSubscription();
  const { hasPaymentMethod } = usePaymentMethod();

  const handleReactivateSubscription = () => {
    Events.reactivatePlan();
    reactivateSubscription.mutate(undefined, {
      onSuccess: () => {
        toast.success("Your Read plan has been successfully reactivated");
      },
      onError: () => {
        toast.error(
          "Something went wrong and your plan could not be reactivated. Please try again or reach out to support@read.ai if the problem persists."
        );
      },
    });
  };

  return (
    <BillingLinkButton
      testId="billing-reactivate-plan"
      variant="text"
      onClick={handleReactivateSubscription}
      loading={reactivateSubscription.isPending}
      disabled={!hasPaymentMethod}
      disabledTooltip="You must add a payment method before reactivating your plan"
    >
      Reactivate plan
    </BillingLinkButton>
  );
};

export default ReactivatePlanButton;
